<template>
  <div v-if="$userInfo.isSystemAdministrator">
    <app-detail-header :show-toggle="true"
      :show-new="false"
      :show-print="false"
      :show-delete="false"
      :show-save="true"
      :show-lock="false"
      :show-cancel="true"
      :show-edit="true"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <flexiquote-module-side-menu v-if="entity"
          :entity-name="entity.modDesc" />
      </div>
      <div class="column">
        <router-view v-if="entity"
          ref="currentChild"
          v-model="entity"
          :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import FlexiquoteModuleSideMenu from './FlexiquoteModuleSideMenu.vue'
import SuperadminFlexiquoteModuleRoutes from './route-types'
import FlexiquoteModuleService from './flexiquoteModuleService'
import StoreMixin from './storeMixin'
import FlexiquoteModuleValidation from './FlexiquoteModuleValidation'
import HttpStatus from '@/components/http-status'

export default {
  name: 'FlexiquoteModuleView',
  components: {
    AppDetailHeader,
    FlexiquoteModuleSideMenu
  },
  mixins: [StoreMixin, FlexiquoteModuleValidation],
  data() {
    return {
      entity: null
    }
  },
  computed: {
  },
  created() {
    this.getEntity()
  },
  methods: {
    async getEntity(reset = false) {
      this.$showSpinner()
      try {
        if (reset) {
          this.clearSnapshots(this.$route.params.moduleId)
        }
        if (!this.currentSnapshot) {
          await this.getStoreItem(this.$route.params.moduleId)
        }
        this.entity = _cloneDeep(this.currentSnapshot)
      } catch (e) {
        this.$notification.openMessageXhrError('', e)
      }
      this.$hideSpinner()
    },
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          this.save()
          break
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
      }
    },
    cancel() {
      this.clearSnapshots(this.entity?.flexiQuoteModuleId)
      this.$router.push({ name: SuperadminFlexiquoteModuleRoutes.FlexiquoteModuleListView.name })
    },
    async save() {
      const title = 'FlexiQuote Module'

      this.$v.$touch()
      if (this.$v.$error) {
        this.$notification.openNotificationWithType('danger', title, 'Please fix validation errors before saving')
        return false
      }

      try {
        this.$showSpinner('Saving...')
        this.saveSnapshot(this.entity)

        let response
        if (this.entity.isNew) {
          response = await FlexiquoteModuleService.postEntity(this.entity)
        } else if (this.snapshotDiff) {
          response = await FlexiquoteModuleService.putEntity(this.entity)
        } else {
          this.$notification.openNotificationWithType('warning', title, 'No changes. Not saved')
          return false
        }

        if (response.status === HttpStatus.NO_CONTENT) {
          await this.getEntity(true)
          this.$notification.openNotificationWithType('success', title, 'Save successful')
        } else if (response.status === HttpStatus.CREATED) {
          this.entity.isNew = false
          this.clearSnapshots(this.entity.flexiQuoteModuleId)
          this.saveSnapshot(this.entity)
          this.$notification.openNotificationWithType('success', title, 'New module added')
        }

        this.$router.push({ name: SuperadminFlexiquoteModuleRoutes.FlexiquoteModuleListView.name })
        return true
      } catch (e) {
        this.$notification.openMessageXhrError('', e)
        return false
      } finally {
        this.$hideSpinner()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearSnapshots(this.entity?.flexiQuoteModuleId)
    this.setReturnRoute({})
    next()
  }
}
</script>

<style scoped>
</style>

